import { api } from 'app/api';
import { ApiResponse, CompanyDto } from 'dtos';

export const getCompanies = async (): Promise<ApiResponse<CompanyDto[]>> =>
  await api.get('companies').then(res => res.data);

export const getCompany = async (companyId: string): Promise<ApiResponse<CompanyDto>> =>
  await api.get(`companies/${companyId}`).then(res => res.data);
